import FeatureRequest from "@/modules/feature-request/FeatureRequest";

const routes = [
  {
    path: 'feature-requests',
    name: 'feature_requests',
    component: FeatureRequest,
    meta: {
      requiresAuth: true
    }
  }
];

export {routes}
